document.addEventListener("DOMContentLoaded", function () {
    let tooltip = document.querySelector(".preorder-tooltip");

    if (!tooltip) return;

    let isHovering = false; // Track hover state

    function showTooltip(event) {
        const badge = event.target.closest(".hengam-preorder-badge");
        if (!badge) return;

        tooltip = document.querySelector(".preorder-tooltip"); // Re-fetch the tooltip in case it was re-rendered
        if (!tooltip) return;

        isHovering = true;
        tooltip.classList.add("show-tooltip");

       // console.log("Tooltip shown for:", badge);
    }

    function hideTooltip() {
        setTimeout(() => {
            if (!isHovering) {
                tooltip.classList.remove("show-tooltip");
               // console.log("Tooltip hidden");
            }
        }, 200); // Small delay to prevent flickering
    }

    document.body.addEventListener("mouseover", function (event) {
        if (event.target.closest(".hengam-preorder-badge") || event.target.closest(".preorder-tooltip")) {
            isHovering = true;
            showTooltip(event);
        }
    });

    document.body.addEventListener("mouseout", function (event) {
        // Check if the mouse left **both** the badge and tooltip
        if (!event.relatedTarget ||
            (!event.relatedTarget.closest(".hengam-preorder-badge") &&
                !event.relatedTarget.closest(".preorder-tooltip"))) {
            isHovering = false;
            hideTooltip();
        }
    });

    // **MutationObserver to detect new elements**
    const observer = new MutationObserver(() => {
        tooltip = document.querySelector(".preorder-tooltip"); // Ensure tooltip exists
    });

    observer.observe(document.body, { childList: true, subtree: true });

    //console.log("MutationObserver started, waiting for changes...");
});
